import React from "react";
import "./loading.scss";

export const Loading = () => (
  <div className="map-loading">
    <div className="map-loading-icon"></div>
  </div>
);
